// extracted by mini-css-extract-plugin
export default {"round":"round--FaPER","klarna":"klarna--QCjnG","facebook":"facebook--dQZU4"};